import { useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { useHomeGamesWidget } from '@swf/poker';

const useFocusGamesList = (clubId?: number) => {
  const { widgetDispatch } = useHomeGamesWidget();
  const isEmbedded = useSelector(select.device.isEmbedded);

  const handleFocus = useCallback(() => {
    widgetDispatch.fetchLobbyData({ clubId });
  }, [widgetDispatch, clubId]);

  useEffect(() => {
    window.addEventListener('focus', handleFocus);

    return () => {
      window.removeEventListener('focus', handleFocus);
    };
  }, [handleFocus, isEmbedded]);
};

export default useFocusGamesList;
